import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AddressModel } from 'app/_models/admin/supplier-interface/address.model';
import { CapabilityKind } from 'app/_models/admin/supplier-interface/capability.kind';
import { InterfaceKindInfoModel } from 'app/_models/admin/supplier-interface/interface.kind.info.model';
import { SupplierDocumentKind } from 'app/_models/admin/supplier-interface/supplier.document.kind';
import { SupplierDocumentStatusKind } from 'app/_models/admin/supplier-interface/supplier.document.status.kind';
import { SupplierDocumentsResponse } from 'app/_models/admin/supplier-interface/supplier.documents.response';
import { SupplierInterfaceData } from 'app/_models/admin/supplier-interface/supplier.interface.data';
import { SupplierRequestData } from 'app/_models/admin/supplier-interface/supplier.request.data';
import { BranchModel } from 'app/_models/common/branch.model';
import { AdminSupplierInterfaceService } from 'app/_services/admin/admin-supplier-interface.service';
import { AdminService } from 'app/_services/admin/admin.service';
import { MainService } from 'app/_services/main.service';

@Component({
  selector: 'app-admin-supplier-documents',
  standalone: false,
  templateUrl: './admin-supplier-documents.component.html',
  styleUrl: './admin-supplier-documents.component.scss'
})
export class AdminSupplierDocumentsComponent {
  supplierInterfaceData: SupplierInterfaceData;
  interfaceKinds: InterfaceKindInfoModel[];
  interfaceKindInfo: InterfaceKindInfoModel;
  branches: { [key: number]: BranchModel };
  request: SupplierRequestData = new SupplierRequestData();
  response: SupplierDocumentsResponse;
  busy = false;

  constructor(
    public adminSupplierInterfaceService: AdminSupplierInterfaceService,
    public adminService: AdminService,
    public mainService: MainService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activatedRoute.data
      .subscribe((data: any) => {
        this.supplierInterfaceData = data.supplierInterfaceData;
        this.request.DocumentKind = SupplierDocumentKind.DeliveryNote;
        this.request.DocumentStatus = SupplierDocumentStatusKind.All;
        this.request.DocumentFromDate = new Date(new Date().setDate(new Date().getDate() - 1));
        this.request.DocumentFromDate.setHours(0, 0, 0, 0);
        this.request.DocumentToDate = new Date(new Date().setDate(new Date().getDate() + 1));
        this.request.DocumentToDate.setHours(0, 0, 0, 0);
        this.setInterfaceKinds(this.request.DocumentKind)

        this.adminService.getBranchesDictionary().subscribe(branchDict => this.branches = branchDict);
      });
  }

  setInterfaceKinds(documentKind: SupplierDocumentKind) {
    const capabilityKind = documentKind === SupplierDocumentKind.DeliveryNote ? CapabilityKind.DeliveryNotes : CapabilityKind.Invoices;
    const interfaceKindInfos = this.adminSupplierInterfaceService
      .getSortedInterfaceKindInfos(this.supplierInterfaceData.InterfaceKindInfos)
      .filter(interfaceKind => {
        let ok = false;
        const hasDocuments = (interfaceKind.Capabilities & capabilityKind) === capabilityKind;
        if ((hasDocuments) && this.supplierInterfaceData.InterfaceData.some(i => i.IntType === interfaceKind.InterfaceKind)) { ok = true; }
        return ok;
      });
    this.interfaceKinds = interfaceKindInfos;
  }

  setInterfaceData(intType: number) {
    this.supplierInterfaceData.InterfaceData.forEach(id => {
      if ((intType === id.IntType)) {
        this.request.InterfaceData = id;
      }
    });
  }



  supplierGetInterfaceDocuments() {
    this.busy = true;
    this.response = null;
    this.adminService.supplierInterfaceGetSupplierDocuments(this.request)
      .subscribe(response => {
        this.response = response;
        this.busy = false;
      });
  }

  getStatusString(status: SupplierDocumentStatusKind): string {
    switch (status) {
      case SupplierDocumentStatusKind.Error:
        return 'ERROR!';
      case SupplierDocumentStatusKind.None:
        return '-';
      case SupplierDocumentStatusKind.Downloaded:
        return 'opgehaald';
      case SupplierDocumentStatusKind.Processed:
        return 'verwerkt';
    }
  }

  stringSizeInKB(str: string): number {
    // Encodeer de string als UTF-8 en meet het aantal bytes
    const bytes = new TextEncoder().encode(str).length;

    // Reken bytes om naar kilobytes (1 kB = 1024 bytes)
    const kilobytes = bytes / 1024;

    return kilobytes;
  }


}
